export default __webpack_public_path__ + "dea9f6096fee5e4ab4f69f0cbdbe9fce.svg";